import { BASE_QUERY_PRO, DEFAULT_SECTION_TOP_COUNT, ruleNewsPlus } from '../shared/configs';

enum SECTION_ENUM {
  BANKRUPTCY = 'Bankruptcy',
  DISTRESS = 'Distress',
  COMMENTARY_AND_ANALYSIS = 'Commentary & Analysis'
}

const BANKRUPTCY_QUERIES = {
  BANKRUPTCY_QUERY: 'pro bankruptcy bankruptcy',
  DISTRESS_QUERY: 'pro bankruptcy distress',
  PEOPLE_QUERY: 'pro bankruptcy people',
  COMMENTARY_ANALYSIS_QUERY: 'pro bankruptcy commentary analysis'
};

const { BANKRUPTCY_QUERY, DISTRESS_QUERY, PEOPLE_QUERY, COMMENTARY_ANALYSIS_QUERY } = BANKRUPTCY_QUERIES;

const MAIN = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [BANKRUPTCY_QUERY, DISTRESS_QUERY, PEOPLE_QUERY]
        }
      }
    ],
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = {
  ...MAIN,
  ...DEFAULT_SECTION_TOP_COUNT
};

const BANKRUPTCY = {
  ...BASE_QUERY_PRO,
  query: { ...BASE_QUERY_PRO.query, or: [{ terms: { key: 'SectionType', value: [BANKRUPTCY_QUERY] } }] }
};

const DISTRESS = {
  ...BASE_QUERY_PRO,
  query: { ...BASE_QUERY_PRO.query, or: [{ terms: { key: 'SectionType', value: [DISTRESS_QUERY] } }] }
};

const COMMENTARY_ANALYSIS = {
  ...BASE_QUERY_PRO,
  query: { ...BASE_QUERY_PRO.query, or: [{ terms: { key: 'SectionType', value: [COMMENTARY_ANALYSIS_QUERY] } }] }
};

const MORE_LIST = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [BANKRUPTCY_QUERY, DISTRESS_QUERY, PEOPLE_QUERY, COMMENTARY_ANALYSIS_QUERY]
        }
      }
    ],
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus]
  }
};

export { MAIN, SECTION_TOP, BANKRUPTCY, DISTRESS, COMMENTARY_ANALYSIS, MORE_LIST, SECTION_ENUM };
